import { render, staticRenderFns } from "./SquareSVG.vue?vue&type=template&id=30450bf8&scoped=true"
import script from "./SquareSVG.vue?vue&type=script&lang=js"
export * from "./SquareSVG.vue?vue&type=script&lang=js"
import style0 from "./SquareSVG.vue?vue&type=style&index=0&id=30450bf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30450bf8",
  null
  
)

export default component.exports